module.exports = __webpack_public_path__ + "img/manmangongsi2.2c4156da.png";